import type { SVGProps } from 'react';

const SvgMessageOnLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <circle cx={22} cy={2} r={2} fill='#FF5A5A' />
    <path
      d='M21 18L15.2988 13.249M21 18V6C21 5.44772 20.5523 5 20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18ZM3.14617 18L8.8474 13.249M3 8L10.7721 14.045C11.4943 14.6067 12.5057 14.6067 13.2279 14.045L21 8'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgMessageOnLt;
